<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Global Feature Codes</h1>
        <div class="modal-actions col-2">
          <el-button
            type="primary"
            @click="createOperation"
            :disabled="codeInUse"
          >
            Create
          </el-button>
          <el-button type="default" @click="cancelOperation">Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group">
        <el-col :span="13">
          <el-input v-model="code" placeholder="Code">
            <template slot="prefix">Code</template>
            <template v-if="codeInUse" slot="append">In use!</template>
          </el-input>
        </el-col>
        <el-col :span="1"/>
        <el-col :span="10">
          <el-select v-model="numvar" placeholder="Variable" clearable>
            <el-option
              v-for="(numVar, idx) in numvarOptions"
              :key="idx"
              :value="numVar"
              :label="numVar"
            />
            <template slot="prefix">Variable</template>
          </el-select>
        </el-col>
      </div>
      <div class="inline-form-group">
        <el-tag class="mb-10" type="warning">
          <i class="el-icon-warning" style="margin-right: 4px;"></i>
          Feature code must not match #0, #1, ## &amp; #*
          and must start with either # or *.
        </el-tag>
      </div>

      <el-input v-model="createForm.comment" placeholder="Enter description">
        <template slot="prefix">Description</template>
      </el-input>

      <div class="mt-20">
        <h2 class="form-section-header">When this code is dialed</h2>
        <div class="inline-form-group">
          <el-col :span="24">
            <destination-selector
              :draggable="true"
              :showHeader="false"
              :draggableDestTypes="draggableDestTypes"
              :clearFields="clearFormFields"
              @destinationsSelected="onDestinationsSelection"
              title=""
            />
          </el-col>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import DestinationSelector from "@/components/DestinationSelector";

export default {
  name: "GlobalFeaturesCodeCreateForm",

  props: {
    createVisible: { required: true },
    codeInUse: { required: true },
    clearFormFields: { required: true },
    createProcessing: { required: true },
    draggableDestTypes: { required: true }
  },

  components: {
    DestinationSelector
  },

  data() {
    return {
      numvar: '',
      code: '',
      numvarOptions: ['EXT', 'NUM'],
      createForm: {
        tenantId: 0,
        code: '',
        numvar: '',
        comment: '',
        destinations: []
      }
    };
  },

  watch: {
    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    code(val) {
      if (val) {
        this.createForm.code = val;
        if (this.createForm.numvar) {
          this.$emit('checkFeatureCode', `${val}[${this.createForm.numvar}]`);
          return;
        }
        this.$emit('checkFeatureCode', val);
      }
    },

    numvar(val) {
      if (val !== '') {
        this.createForm.numvar = val;
        if (this.createForm.code !== '') {
          this.$emit('checkFeatureCode', `${this.createForm.code}[${val}]`);
        }
      } else {
        this.$emit('checkFeatureCode', this.createForm.code);
      }
    }
  },

  methods: {
    createOperation() {
      const createBody = { ...this.createForm };

      if (
        createBody.destinations.length > 1 &&
        createBody.destinations.find(dst => !dst.id)
      ) {
        this.$notify({
          title: 'Empty Destination field',
          message: 'No destination field should be left empty',
          type: 'error'
        });
        return;
      }

      if (
        createBody.destinations.length === 1 &&
        createBody.destinations[0].id === null
      ) {
        createBody.destinations = [];
      } else {
        createBody.destinations.forEach((dst, idx) => (dst.order = idx + 1));
      }

      this.$emit("createOperation", createBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearFields() {
      this.numvar = '';
      this.code = '';

      this.createForm = {
        tenantId: 0,
        code: '',
        comment: '',
        destinations: []
      };

      this.$emit("formsCleared");
    },

    remoteMethodForAvailableNums(query) {
      this.$emit("remoteMethodForAvailableNums", query);
    },

    onDestinationsSelection(destinations) {
      this.createForm.destinations = [...destinations];
    }
  }
};
</script>
